import { render, staticRenderFns } from "./TicketRecentEmergencyTotals.vue?vue&type=template&id=b02afaca&scoped=true&"
import script from "./TicketRecentEmergencyTotals.vue?vue&type=script&lang=js&"
export * from "./TicketRecentEmergencyTotals.vue?vue&type=script&lang=js&"
import style0 from "./TicketRecentEmergencyTotals.vue?vue&type=style&index=0&id=b02afaca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02afaca",
  null
  
)

export default component.exports